import './common'
import axios from 'axios'

export default {
    getWeekTypes: (params) => axios.get('/week-types', { params }),
    putWeekType: (id, data) => axios.put(`/week-types/${id}`, data),
    postWeekType: (data) => axios.post('/week-types', data),
    deleteWeekType: (id) => axios.delete(`/week-types/${id}`)
}
